import React from "react";
import { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { Button, Input, Select, DatePicker } from "antd";
import { CustomLabel } from "../../../utilities/utll";
import {
  DownCircleOutlined,
  FilterOutlined,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { useIrnStore } from "../../../store/useIrnstore";
import dayjs from "dayjs";

export const ListRegisterForm = () => {
  const {
    irnList,
    getIrns,
    getPeriods,
    periods,
    downloadDoc,
    getPrintDetailByIrn,
  } = useIrnStore();

  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  useEffect(() => {
    getPeriods();
  }, []);
  useEffect(() => {
    if (periods.length > 0 && !selectedPeriod) {
      const today = periods.find((p) => p.PeriodName === "Today") || periods[0];

      if (today) {
        setSelectedPeriod(today.PeriodId);

        const from = dayjs(today.FromDate);
        const to = dayjs(today.Todate);

        setFromDate(from);
        setToDate(to);

        getIrns(from.format("YYYY-MM-DD"), to.format("YYYY-MM-DD"));
      }
    }
  }, [periods]);
  const handleDownload = async (docName) => {
    const blob = await downloadDoc(docName);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = docName;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handlePeriodChange = (value) => {
    setSelectedPeriod(value);
    const selected = periods.find((p) => p.PeriodId === value);

    if (selected) {
      if (selected.PeriodName === "Custom") {
        // For custom, clear dates and let user select
        setFromDate(null);
        setToDate(null);
      } else {
        // Set dates from the selected period
        setFromDate(dayjs(selected.FromDate));
        setToDate(dayjs(selected.Todate));
      }
    }
  };

  const handleFilter = async () => {
    // Validation
    if (!selectedPeriod) {
      alert("Please select a period");
      return;
    }

    if (!fromDate || !toDate) {
      alert("Please select both From Date and To Date");
      return;
    }

    try {
      const fromDateStr = fromDate.format("YYYY-MM-DD");
      const toDateStr = toDate.format("YYYY-MM-DD");
      await getIrns(fromDateStr, toDateStr);
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      alert("An error occurred while fetching data");
    }
  };
  const isCustomPeriod = () => {
    const selected = periods.find((p) => p.PeriodId === selectedPeriod);
    return selected && selected.PeriodName === "Custom";
  };

  return (
    <>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Period"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            value={selectedPeriod}
            onChange={handlePeriodChange}
            options={periods.map((period) => ({
              value: period.PeriodId,
              label: period.PeriodName,
            }))}
          />
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"IRN From Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            value={fromDate}
            onChange={(date) => setFromDate(date)}
            disabled={!isCustomPeriod() && selectedPeriod !== null}
          />
        </Col>

        <Col xl={3} md={6}>
          <CustomLabel children={"IRN To Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            value={toDate}
            onChange={(date) => setToDate(date)}
            disabled={!isCustomPeriod() && selectedPeriod !== null}
          />
        </Col>
        <Col xl={3} md={6} style={{ textAlign: "center", marginTop: "1rem" }}>
          <Button
            type="primary"
            icon={<FilterOutlined />}
            size="large"
            style={{
              marginRight: "0.75rem",
              backgroundColor: "#1aa8c4ff", // elegant green
              borderColor: "#1a94c4ff",
              boxShadow: "0 2px 6px rgba(2, 2, 65, 0.3)",
            }}
            onClick={handleFilter}
          >
            Filter
          </Button>

          {/* <Button
            icon={<DownCircleOutlined />}
            size="large"
            style={{
              borderColor: "#1890ff",
              color: "#1890ff",
            }}
            onClick={handleDownload}
          >
            Download
          </Button> */}
        </Col>
      </Row>
    </>
  );
};
